import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02a3259a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["financial-privacy-button", { 'financial-privacy-button--hidden': !_ctx.valuesVisible }]),
    type: "button",
    "aria-label": _ctx.valuesVisible ? 'Ocultar valores financeiros' : 'Mostrar valores financeiros',
    title: _ctx.valuesVisible ? 'Ocultar valores financeiros' : 'Mostrar valores financeiros',
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFinanceValuesVisibility && _ctx.toggleFinanceValuesVisibility(...args)))
  }, [
    _createElementVNode("i", {
      class: _normalizeClass(_ctx.valuesVisible ? 'ph ph-eye' : 'ph ph-eye-slash'),
      "aria-hidden": "true"
    }, null, 2)
  ], 10, _hoisted_1))
}